module.exports = __webpack_public_path__ + "images/emoji/house.a0538672e5bf81a9993d.png";